export default __webpack_public_path__ + "static/media/Contact_Icon-01.5d9f2483.png";